<template>
  <div class="content_box">
    <div id="deptManage">
      <div class="leftTree">
        <el-tree
          :data="deptTree"
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
          default-expand-all
          v-loading="deptTreeLoading"
        ></el-tree>
      </div>
      <div class="rightCon contentPadding42" id="ManageTable">
        <div class="headTitle">
          <img src="@/assets/imgs/icon/dept_logo.png" alt />
          部门管理
        </div>
        <el-form :inline="true" :model="searchObj" class="demo-form-inline">
          <el-form-item label="部门名称" style="margin-right: 30px">
            <el-input
              v-model.trim="searchObj.name"
              placeholder="请输入部门名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门简称" style="margin-right: 30px">
            <el-input
              v-model.trim="searchObj.shortName"
              placeholder="请输入部门简称"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="searchObj.state" placeholder="不限">
              <el-option label="不限" value></el-option>
              <el-option label="启用" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSearch"
              class="bg5584FF formBotton"
              style="margin-left: 40px"
              >查询</el-button
            >
            <el-button type="info" @click="onReset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <hr />
        <el-button
          type="primary"
          size="small"
          class="bg5584FF"
          @click="addDept"
        >
          <i class="el-icon-plus"></i> 新增部门
        </el-button>
        <div style="height: 20px"></div>
        <el-table
          v-loading="loading"
          :data="deptList"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        >
          <!-- <el-table-column align="center" type="index" width="100" label="排序"></el-table-column> -->

          <el-table-column
            align="center"
            prop="name"
            label="部门名称"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="detail" @click="handleDetail(scope.row)">{{
                scope.row.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="shortName"
            label="部门简称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="code"
            label="部门编码"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="superDepartment"
            label="上级部门"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            prop="area"
            label="所属地区"
          ></el-table-column>
          <el-table-column align="center" prop="state" label="状态" width="150">
            <template slot-scope="scope">{{
              scope.row.state == 0 ? "启用" : "停用"
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="order"
            label="顺序"
            width="120"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="editDept(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="deleteDept(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox">
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination> -->
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total,  prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 新增部门 -->
      <el-dialog
        title="新增部门"
        :visible.sync="addDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        @closed="addDialogHandleClose"
      >
        <div class="addUser">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="135px"
            class="demo-ruleForm"
            size="small"
            v-loading="addLoading"
          >
            <el-row>
              <el-col span="12">
                <el-form-item label="部门名称：" prop="name">
                  <el-input
                    v-model.trim="ruleForm.name"
                    placeholder="请输入部门名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="部门简称：" prop="shortName">
                  <el-input
                    v-model.trim="ruleForm.shortName"
                    placeholder="请输入部门简称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="所属地区：">
                  <el-input
                    v-model="ruleForm.area"
                    placeholder="请选择所属地区"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="部门编码：" prop="code">
                  <el-input
                    v-model.trim="ruleForm.code"
                    placeholder="请输入部门编码"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="上级部门：">
                  <el-select
                    v-model="ruleForm.superDepartment"
                    placeholder="请选择上级部门"
                  >
                    <el-option label="请选择" value></el-option>
                    <el-option
                      v-for="item in superDepartmentList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="状态：" prop="state">
                  <el-radio-group v-model="ruleForm.state">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col span="24">
                <el-form-item label="显示顺序：" prop="order">
                  <el-input
                    v-model.trim="ruleForm.order"
                    placeholder
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btnBox">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >保存</el-button
            >
            <el-button @click="addDialogVisible = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 查看详情 -->
      <el-dialog
        title="查看部门"
        :visible.sync="detailDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
      >
        <div class="addUser">
          <el-form
            :model="editRuleForm"
            ref="ruleForm"
            label-width="135px"
            class="demo-ruleForm"
            size="small"
          >
            <el-row>
              <el-col span="12">
                <el-form-item label="部门名称：" prop="name">
                  <el-input
                    v-model="editRuleForm.name"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="部门简称：" prop="shortName">
                  <el-input
                    v-model="editRuleForm.shortName"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="所属地区：" prop="area">
                  <el-input
                    v-model="editRuleForm.area"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="部门编码：" prop="code">
                  <el-input
                    v-model="editRuleForm.code"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="上级部门：" prop="superDepartment">
                  <el-input
                    v-model="editRuleForm.superDepartment"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="状态：" prop="state">
                  <el-radio-group v-model="editRuleForm.state" disabled>
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col span="24">
                <el-form-item label="显示顺序：" prop="order">
                  <el-input
                    v-model="editRuleForm.order"
                    placeholder
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
      <!-- 编辑部门 -->
      <el-dialog
        title="编辑部门"
        :visible.sync="editDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        @closed="editDialogHandleClose"
      >
        <div class="addUser">
          <el-form
            :model="editRuleForm"
            ref="editRuleForm"
            :rules="rules"
            label-width="135px"
            class="demo-ruleForm"
            size="small"
            v-loading="editLoading"
          >
            <el-row>
              <el-col span="12">
                <el-form-item label="部门名称：" prop="name">
                  <el-input
                    v-model.trim="editRuleForm.name"
                    placeholder="请输入部门名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="部门简称：" prop="shortName">
                  <el-input
                    v-model.trim="editRuleForm.shortName"
                    placeholder="请输入部门简称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="所属地区：">
                  <el-input
                    v-model="editRuleForm.area"
                    placeholder="请选择所属地区"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="部门编码：">
                  <el-input
                    v-model="editRuleForm.code"
                    placeholder="请输入部门编码"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="上级部门：">
                  <el-input
                    v-model="editRuleForm.superDepartment"
                    placeholder
                    v-if="editRuleForm.superDepartment == '无'"
                    disabled
                  ></el-input>
                  <el-select
                    v-model="editRuleForm.superDepartment"
                    placeholder="请选择上级部门"
                    v-else
                  >
                    <el-option label="请选择" value></el-option>
                    <el-option
                      v-for="item in superDepartmentList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="状态：" prop="state">
                  <el-radio-group v-model="editRuleForm.state">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col span="24">
                <el-form-item label="显示顺序：" prop="order">
                  <el-input
                    v-model.trim="editRuleForm.order"
                    placeholder
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btnBox">
            <el-button type="primary" @click="editSubmitForm('editRuleForm')"
              >保存</el-button
            >
            <el-button @click="editDialogVisible = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 删除弹框 -->
      <el-dialog
        title="删除"
        :visible.sync="deleteDialogVisible"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>确认要删除该条数据？此操作不可逆</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button
            type="normal"
            size="mini"
            @click="deleteDialogVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    // 部门唯一验证
    var onlyCode = (rule, value, callback) => {
      if (!value) {
        // callback();
        return callback(new Error("请输入部门编码")); // 必填验证  此处非必填
      }
      this.$axios
        .get(`/system/department/searchDeptCodeIsExisted/${value}`)
        .then((res) => {
          console.log(res);
          if (res.data == 1) {
            callback(new Error("部门编码已存在"));
          } else if (res.data == 0) {
            callback();
          }
        });
    };
    return {
      addDialogVisible: false, // 新增用户
      detailDialogVisible: false, //查看用户
      allotDialogVisible: false, //分配角色
      editDialogVisible: false, //编辑用户
      deleteDialogVisible: false, //删除
      currentPage: 1,
      pageNum: 1,
      total: 0,
      cityCode: "",
      cityNmae: "",
      superDepartmentList: [],
      loading: false,
      addLoading: false,
      editLoading: false,
      deptTreeLoading: false,
      deptTree: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      searchObj: {
        name: "",
        shortName: "",
        state: "",
      },
      deptList: [],
      ruleForm: {
        name: "",
        shortName: "",
        area: "",
        code: "",
        superDepartment: "",
        state: 0,
        order: "",
        areaCode: "",
      },
      editRuleForm: {
        name: "",
        shortName: "",
        area: "",
        code: "",
        superDepartment: "",
        state: 0,
        order: "",
        areaCode: "",
      },
      rules: {
        name: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        shortName: [
          { required: true, message: "请输入部门简称", trigger: "blur" },
        ],
        area: [{ required: true, message: "请选择所属地区", trigger: "blur" }],
        code: [{ required: true, validator: onlyCode, trigger: "blur" }],
        superDepartment: [
          { required: true, message: "请选择上级部门", trigger: "change" },
        ],
        state: [{ required: true, message: "请选择部门状态", trigger: "blur" }],
        order: [{ required: true, message: "请输入顺序", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getDeptTree().then(() => {
      this.getData(this.pageNum, this.cityCode);
      this.getDeptList();
    });
  },
  methods: {
    async getData(pageNum, cityCode) {
      this.loading = true;
      this.$axios
        .get("/system/department/searchDepartmentPageList", {
          params: {
            pageNum,
            pageSize: 10,
            areaCode: cityCode,
            name: this.searchObj.name,
            shortName: this.searchObj.shortName,
            state: this.searchObj.state,
          },
        })
        .then((res) => {
          this.deptList = res.data;
          this.total = res.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDeptTree() {
      this.deptTreeLoading = true;
      return new Promise((resolve) => {
        this.$axios
          .get("/system/department/searchDepartmentTree")
          .then((res) => {
            this.deptTreeLoading = false;
            this.deptTree = res.data;
            console.log(res.data);
            this.cityCode = res.data[0].children[0].code;
            let reg = /[\u4e00-\u9fa5]/g;
            this.cityNmae = res.data[0].children[0].name.match(reg).join("");
            console.log(this.cityNmae);
            resolve();
          })
          .catch(() => {
            this.deptTreeLoading = false;
          });
      });
    },
    getDeptList() {
      this.$axios
        .get(`/system/department/searchDepartmentNames/${this.cityCode}`)
        .then((res) => {
          this.superDepartmentList = res.data;
        });
    },
    onSearch() {
      console.log(this.searchObj);
      this.getData(this.pageNum, this.cityCode);
    },
    onReset() {
      for (const key in this.searchObj) {
        this.searchObj[key] = "";
      }
      this.pageNum = 1;
      this.getData(this.pageNum, this.cityCode);
      this.currentPage = 1;
    },
    addDept() {
      //新增部门
      this.addDialogVisible = true;
      this.ruleForm.area = this.cityNmae;
    },
    submitForm(formName) {
      //新增提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.areaCode = this.cityCode;
          this.addLoading = true;
          this.$axios
            .post("/system/department/insertDepartmentInfo", this.ruleForm)
            .then((res) => {
              console.log(res);
              Message.success("新增成功");
              this.addDialogVisible = false;
              this.addLoading = false;
              this.getData(this.pageNum, this.cityCode);
            })
            .catch(() => {
              this.addLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editDept(row) {
      this.editDialogVisible = true;
      this.editLoading = true;
      this.$axios
        .get(`/system/department/selectDepartmentDetail/${row.id}`)
        .then((res) => {
          this.editLoading = false;
          this.editRuleForm = res.data;
        })
        .catch(() => {
          this.editLoading = false;
        });
    },
    editSubmitForm(formName) {
      //修改提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editRuleForm.areaCode = this.cityCode;
          this.editLoading = true;
          this.$axios
            .put("/system/department/updateDepartmentIfo", this.editRuleForm)
            .then((res) => {
              console.log(res);
              Message.success("已修改");
              this.editDialogVisible = false;
              this.editLoading = false;
              this.getData(this.pageNum, this.cityCode);
              this.currentPage = 1;
            })
            .catch(() => {
              this.editLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      //新增重置
      this.$refs[formName].resetFields();
    },
    handleDetail(row) {
      //查看用户
      console.log(row);
      this.detailDialogVisible = true;
      this.$axios
        .get(`/system/department/selectDepartmentDetail/${row.id}`)
        .then((res) => {
          this.editRuleForm = res.data;
        });
    },

    deleteDept(row) {
      this.deptId = row.id;
      this.deleteDialogVisible = true;
    },
    sureDelete() {
      // 删除
      this.$axios
        .delete(`/system/department/deleteDepartmentIfo/${this.deptId}`)
        .then(() => {
          Message.success("已删除");
          this.deleteDialogVisible = false;
          this.currentPage = 1;
          this.getData(this.pageNum, this.cityCode);
        });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.getData(val);
    },
    handleNodeClick(data) {
      this.cityCode = data.code;
      let reg = /[\u4e00-\u9fa5]/g;
      this.cityNmae = data.name.match(reg).join("");
      console.log(this.cityNmae);
      this.getData(this.pageNum, this.cityCode);
    },
    addDialogHandleClose() {
      this.$refs.ruleForm.resetFields();
      // this.rueForm.superDepartment = "";
    },
    editDialogHandleClose() {
      this.$refs.editRuleForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
#deptManage {
  box-shadow: 0px 0px 50px #ccc;
  height: 100%;
  display: flex;
  .leftTree {
    width: 260px;
    height: 100%;
    background-color: rgba(247, 248, 250, 1);
    box-sizing: border-box;
    padding: 20px 0px 20px 0px;
  }
  .rightCon {
    width: calc(100% - 260px);
    border-left: 1px solid rgb(220, 223, 230);
  }
}
#deptManage /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .el-tree-node:focus > .el-tree-node__content {
    background: rgba(247, 248, 250, 1);
    .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
#deptManage .el-tree {
  background: rgba(247, 248, 250, 1);
}
.headTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 24px;
    padding-left: 2px;
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
.el-dialog {
  .addUser {
    .el-form-item {
      .el-select {
        width: 100%;
      }
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>